import { SVGProps } from "react"

const TransferVertical = ({ color, height, width, ...props }: SVGProps<SVGSVGElement>) => {
    return (
        <svg {...props} width={width} height={height} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.4722 4.5L10.4722 20.5L4.47217 15" stroke={color ?? "#1C274C"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path opacity="0.5" d="M14.4722 20.5L14.4722 4.5L20.4722 10" stroke={color ?? "#1C274C"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}

export default TransferVertical